import zipObject from 'lodash/zipObject'
import keys from 'lodash/keys'
import values from 'lodash/values'

const promiseAllValues = async (object) => {
  return zipObject(keys(object), await Promise.all(values(object)))
}

export default promiseAllValues
